import React, { useState } from 'react'
import img from '../../images/management 1.png'
import img1 from '../../images/evaluation 1.png'
import img2 from '../../images/project-management 1.png'
import img3 from '../../images/compensation 1.png'
import img4 from '../../images/efficacy 1.png'
import img5 from '../../images/project-management (1) 1.png'
import { useLanguage } from "../../Providers/LanguageContext";
const AccordionDisplay = () => {
  const [active, setActive] = useState(0);
  const { language, currentLanguage } = useLanguage();
  const points = [
    {
      head: language.accordion_head_1,
      pointHead: language.accordion_point_head_1,
      point: language.accordion_point_1
    },

    {
      head: language.accordion_head_2,
      pointHead: language.accordion_point_head_2,
      point: language.accordion_point_2
    },

    {
      head: language.accordion_head_3,
      pointHead: language.accordion_point_head_3,
      point: language.accordion_point_3
    },

    {
      head: language.accordion_head_4,
      pointHead: language.accordion_point_head_4,
      point: language.accordion_point_4
    },
    {
      head: language.accordion_head_5,
      pointHead: language.accordion_point_head_5,
      point: language.accordion_point_5
    },

    {
      head: language.accordion_head_6,
      pointHead: language.accordion_point_head_6,
      point: language.accordion_point_6
    },
  ];

  return (
    <>
      {
        points.map((e, i) => {
          return (
            <div className='accordion_display_wrapper' style={active === i ? { background: '#0c2637' } : {}} onClick={(() => setActive(i))}>
              <img src={img} />
              <div className='accordion_data_div'>
                <h5 style={active === i ? {
                  color: '#fff'
                } : {}} >{e.head}</h5>
                {active === i && <strong style={active === i ? {
                  color: '#fff'
                } : {}}>{e.pointHead} </strong>}
                {active === i && <p style={active === i ? {
                  color: '#fff'
                } : {}}>{e.point} </p>}
              </div>
              {active === i && <i style={{
                color: '#fff'
              }} class="fa-solid fa-minus"></i>}
              {active != i && <i style={{
                color: '#0c2637'
              }} class="fa-solid fa-plus"></i>}
            </div>
          )
        })
      }

    </>
  )
}

export default AccordionDisplay
